import { useParams } from "react-router";
import ButtonGroup from "../../components/ButtonGroup";
import Panel from "../../components/Panel";
import ToggleSwitch from "../../components/ToggleSwitch";
import { useBike, useUpdateBike } from "../../hooks/useBikes";
import { Shock as ShockAPI } from "../../http/onlyclicksApi";
import { translate } from "../../i18n";
import { Language } from "../../types";
import Description, { DescriptionList } from "../Profile/Description";

const Shock = () => {
  const i18n = translate(Language.English);
  const params = useParams<"bikeId">();
  const bikeId = String(params.bikeId);
  const { data: bike, isSuccess } = useBike(bikeId);
  const mutation = useUpdateBike();

  const mutateShock = (shock: ShockAPI) => {
    if (!bike) return;

    return mutation.mutate({
      id: bike.id,
      bike: {
        name: bike.name,
        show_wheels: bike.show_wheels,
        fork: bike.fork,
        shock: shock,
      },
    });
  };

  return (
    <Panel>
      {isSuccess && bike.shock !== undefined && (
        <DescriptionList>
          <Description
            label="Suspension Type"
            value={
              <ButtonGroup>
                <ButtonGroup.Button
                  isActive={bike.shock.type === "air"}
                  onClick={() =>
                    mutateShock({
                      ...bike.shock!,
                      type: "air",
                    })
                  }
                >
                  Air
                </ButtonGroup.Button>
                <ButtonGroup.Button
                  isActive={bike.shock.type === "coil"}
                  onClick={() =>
                    mutateShock({
                      ...bike.shock!,
                      type: "coil",
                      show_volume_spacers: false,
                    })
                  }
                >
                  Coil
                </ButtonGroup.Button>
              </ButtonGroup>
            }
          />
          <Description
            label={i18n.sag}
            value={
              <ToggleSwitch
                checked={bike.shock.show_sag}
                onChange={(b) =>
                  mutateShock({
                    ...bike.shock!,
                    show_sag: b,
                  })
                }
              />
            }
          />
          <Description
            label={i18n.lsc(false)}
            value={
              <ToggleSwitch
                checked={bike.shock.show_lsc}
                onChange={(b) =>
                  mutateShock({
                    ...bike.shock!,
                    show_lsc: b,
                  })
                }
              />
            }
          />
          <Description
            label={i18n.hsc(false)}
            value={
              <ToggleSwitch
                checked={bike.shock.show_hsc}
                onChange={(b) =>
                  mutateShock({
                    ...bike.shock!,
                    show_hsc: b,
                  })
                }
              />
            }
          />
          <Description
            label={i18n.lsr(true, false)}
            value={
              <ToggleSwitch
                checked={bike.shock.show_lsr}
                onChange={(b) =>
                  mutateShock({
                    ...bike.shock!,
                    show_lsr: b,
                  })
                }
              />
            }
          />
          <Description
            label={i18n.hsr(false)}
            value={
              <ToggleSwitch
                checked={bike.shock.show_hsr}
                onChange={(b) =>
                  mutateShock({
                    ...bike.shock!,
                    show_hsr: b,
                  })
                }
              />
            }
          />
          {bike.shock.type === "air" && (
            <Description
              label={i18n.volume_spacers}
              value={
                <ToggleSwitch
                  checked={bike.shock.show_volume_spacers}
                  onChange={(b) =>
                    mutateShock({
                      ...bike.shock!,
                      show_volume_spacers: b,
                    })
                  }
                />
              }
            />
          )}
        </DescriptionList>
      )}
    </Panel>
  );
};

export default Shock;
